import {
  StartSettingModel,
  StartSettingSendAttributes,
  StartSettingGetAttributes,
  StartSettingCollection,
} from 'src/models/StartSettingModel';
import { Notify } from 'quasar';
import {
  StartSettingAdapterInteface,
  ListStartSettingsInput as BaseListStartSettingsInput,
} from 'src/adapter/StartSettingAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListStartSettingsInput = BaseListStartSettingsInput;
export class StartSettingApiClass {
  adapter: StartSettingAdapterInteface;
  constructor(adapter: StartSettingAdapterInteface) {
    this.adapter = adapter;
  }
  async listStartSettings(
    conditions: ListStartSettingsInput
  ): Promise<{ total: number; data: StartSettingCollection }> {
    try {
      conditions?.page;
      const res = await this.adapter.listStartSettings({
        page: conditions.page,
        limit: conditions.limit,
        filter: conditions.filter,
      });
      return {
        total: res.total,
        data: res.data.map(
          (startSetting: StartSettingGetAttributes) =>
            new StartSettingModel(startSetting)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getStartSetting(id: string): Promise<StartSettingModel> {
    try {
      const startSetting = await this.adapter.getStartSetting(id);
      return new StartSettingModel(startSetting);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateStartSetting(
    id: string,
    attributes: StartSettingSendAttributes
  ): Promise<StartSettingModel> {
    try {
      const startSetting = await this.adapter.updateStartSetting(
        id,
        attributes
      );
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new StartSettingModel(startSetting);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
